import {
  required, minLength, sameAs,
} from 'vuelidate/lib/validators';

const validations = {
  currentPassword: {
    required,
  },
  newPassword: {
    required,
    minLength: minLength(6),
  },
  confirmPassword: {
    required,
    sameAs: sameAs('newPassword'),
  },
};

export default validations;
